const {
  apiRequest,
} = require('../ws');

import {
  ENDPOINT_MERCHANT_HELP
} from '../../constants/api';

export function apiHelp(params) {
  return apiRequest(ENDPOINT_MERCHANT_HELP, params);
}
